<div ref:miniMapsBox class='miniMapsBox clearfix'>


	{{#each cities as city, index}}

		<h2 class='city-name'>{{prettyNames[city]}}</h2>


		<div class={{ width > 500 ? "city-container clearfix" : ""}}>
			{{#if width > 500}}
		{{#each map_types as type}}
		<div class='gia-map-container'>
		<img class='mini-map' src='<@baseUrl@>/<@version@>/files/mini-maps/{{city}}_{{type}}.png'>
		<div class='key-container-mini-maps'>

			{{#if type === 'base'}}
			<div class='row-for-outline-color-one-off'>

				<p class='outline-key-text'>2015 gun homicide incident</p>
				<div class='murder dot'>
					<svg>
						<circle cx="9" cy="9" r="2"></circle>
					</svg>
				</div>
			</div>
			{{else}}
			<ScrollerKey sceneIndex={{sceneIndexDict[type]}} miniMaps={{1}} />
			{{/if}}


</div>
		</div>

		{{/each}}

		{{else}}
		<img class='mini-map-gif' src='<@baseUrl@>/<@version@>/files/mini-maps/{{city}}_gif.gif' />
		{{/if}}
</div>



		<div class='mini-map-blurb gia-intro'>

		{{{miniMapBlurbs[index]['html']}}}
		</div>

	{{/each}}

</div>

<style>

svg {
	width: 20px;
}

circle {
	fillColor: #333;
	fillOpacity: 0.2;
}

.row-for-outline-color-one-off {
	display: flex;
	width: 200px;
	justify-content: flex-start;
	align-content: center;
	height: 20px;
	padding-top: 10px;
	font-weight: 900;
	padding-left: 20px;
}

.key-container-mini-maps {
	z-index: 10000;
	position: relative;
	bottom: 0;
	left: 0;
	height: 90px;
	font-family: 'Guardian Text Sans Web';
	font-size: 14px;
	width: 250px;
}

.top-line {
	border-top: 1px #dcdcdc solid;
	/*max-width: 620px;*/
	margin: 0 auto;
	margin-bottom: 20px;
}

.mini-map-blurb {
	margin-bottom: 50px;
}

.city-name {
	font-size: 22px;
	margin-bottom: 10px;
	margin: 0;
	max-width: auto;
	font-family: 'Guardian Egyptian Web';
	font-weight: 900;
	margin-top: 0;
	border-top: 1px #dcdcdc solid;
	padding-top: 5px;
	width: 100%;
	max-width: 1180px;

}

.map-type {
	font-family: 'Guardian Text Sans Web';
	font-size: 14px;
	max-width: 250px;
}

/*.clearfix:after {
   content: ".";
   visibility: hidden;
   display: block;
   height: 0;
   clear: both;
}*/
.gia-map-container {
	/*float: left;*/
	width: 250px;
	display: relative;
}

.city-container {
	margin-bottom: 55px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
}

/*.city-container:after {
  content: ".";
	visibility: hidden;
  flex: auto;
}*/

.mini-map {
	width: 250px;
}

.mini-map-gif {
	width: 100%;
	margin-bottom: 55px;
}

img {
	width: 250px;
}

.chart {
	width: 250px;
	padding-left: 3px;
}

@media (max-width: 1029px) {
	.miniMapsBox {
		max-width: 720px;
		margin: 0 auto;
	}
}

@media (min-width: 1030px){
	.miniMapsBox {
		width: 100%;
	}

	.city-container {
		justify-content: space-between;
	}
}



</style>
<script>
const cities = [ 'nyc', 'baltimore', 'chicago', 'oakland', 'neworleans' ];
const map_types = [ 'base', 'poverty', 'ed', 'black' ];
import miniMapBlurbs from '../miniMapBlurbs.js';
import ScrollerKey from './ScrollerKey.html';

const map_type_dict = {
	base: 'Locations of gun homicides',
	black: 'Percent black',
	poverty: 'Percent below 100% poverty level',
	ed: 'Percent age 25+ residents with no high school degree'
};

const sceneIndexDict = {
	poverty: 3,
	ed: 4,
	black: 5
};

const prettyNames = {
	baltimore: 'Baltimore, Maryland',
	chicago: 'Chicago, Illinois',
	neworleans: 'New Orleans, Louisiana',
	nyc: 'New York, New York',
	oakland: 'Oakland, California'
};

export default {
	data () {
		return {
			map_types,
			cities,
			map_type_dict,
			prettyNames,
			width: 700,
			miniMapBlurbs,
			sceneIndexDict

		};
	},

	onrender () {
		this.container = this.refs.miniMapsBox;
		const self = this;

		window.addEventListener( 'resize', () => {
			self.resize();
		});

		this.resize();
	},

	methods: {
		resize () {
			this.set({
				width: this.container.getBoundingClientRect().width
				// height: this.container.getBoundingClientRect().height
			});
		}
	},
	components: {
		ScrollerKey
	}
};
</script>
